import $ from 'jquery';
import _ from 'lodash';

import { greenImageSize } from './constants';

export const initializeGreenAndGrid = (hole) => {
    // Initialize UL & LR
    var ullatlong = hole.greenToWorld.transformPoint(greenImageSize * 0.2, greenImageSize * 0.2);
    var lrlatlong = hole.greenToWorld.transformPoint(greenImageSize * 0.7, greenImageSize * 0.7);
    var ulxy = hole.greenToView.transformPoint(greenImageSize * 0.2, greenImageSize * 0.2);
    var lrxy = hole.greenToView.transformPoint(greenImageSize * 0.7, greenImageSize * 0.7);
    var ul = { Longitude: ullatlong[0], Latitude: ullatlong[1], X: ulxy[0], Y: ulxy[1] };
    var lr = { Longitude: lrlatlong[0], Latitude: lrlatlong[1], X: lrxy[0], Y: lrxy[1] };

    // Transform Points to be used to create boundary 
    var ptLOG = _.filter(true, hole.PoiData, { 'Name': 'LeftOfGreen' })[0];
    $.extend(ptLOG, ul);
    var ptBOG = _.filter(true, hole.PoiData, { 'Name': 'BackOfGreen1' })[0];
    $.extend(ptBOG, ul);

    var ptROG = _.filter(true, hole.PoiData, { 'Name': 'RightOfGreen' })[0];
    $.extend(ptROG, lr);
    var ptFOG = _.filter(true, hole.PoiData, { 'Name': 'FrontOfGreen' })[0];
    $.extend(ptFOG, lr);
 };